/* rog-topo2.js -- line-only topographic backgrounds with open space (2026-10-16 per Paul).
   Used behind the product-page ATF section (snippets/rog-atf-topo.liquid).
   Topo2.draw(canvas, opts) -> paints at canvas size.
   opts: seed, bg, ink, bold (major line colour), accent (trail colour), fade (0..1 toward bg),
         land: [{type:'ridge', pts:[[x,y]...], w}, {type:'peak', x,y,r}] in 0..1 coords,
         lines (levels), markers (bool) */
(function () {
  function hash(s) { var h = 2166136261; for (var i = 0; i < s.length; i++) { h ^= s.charCodeAt(i); h = Math.imul(h, 16777619); } return h >>> 0; }
  function rng(a) { return function () { a |= 0; a = a + 0x6D2B79F5 | 0; var t = Math.imul(a ^ a >>> 15, 1 | a); t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t; return ((t ^ t >>> 14) >>> 0) / 4294967296; }; }
  function noise(r) {
    var N = 256, p = new Float32Array(N * N); for (var i = 0; i < p.length; i++) p[i] = r();
    function v(x, y) { return p[((y & 255) * N) + (x & 255)]; }
    function s(t) { return t * t * (3 - 2 * t); }
    return function (x, y) { var xi = Math.floor(x), yi = Math.floor(y), xf = s(x - xi), yf = s(y - yi);
      var a = v(xi, yi), b = v(xi + 1, yi), c = v(xi, yi + 1), d = v(xi + 1, yi + 1);
      return a + (b - a) * xf + (c - a) * yf + (a - b - c + d) * xf * yf; };
  }
  function hex(c) { return [parseInt(c.substr(1, 2), 16), parseInt(c.substr(3, 2), 16), parseInt(c.substr(5, 2), 16)]; }
  function mix(c, bg, f) { var a = hex(c), b = hex(bg); return 'rgb(' + a.map(function (v, i) { return Math.round(v + (b[i] - v) * f); }).join(',') + ')'; }
  function segDist(px, py, ax, ay, bx, by) { var dx = bx - ax, dy = by - ay, l = dx * dx + dy * dy, t = l ? ((px - ax) * dx + (py - ay) * dy) / l : 0; t = Math.max(0, Math.min(1, t)); var x = ax + t * dx - px, y = ay + t * dy - py; return Math.sqrt(x * x + y * y); }

  function draw(cv, o) {
    var dpr = o.dpr || 1, W = cv.width / dpr, H = cv.height / dpr, S = Math.max(W, H), ctx = cv.getContext('2d');
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    var r = rng(hash(o.seed || 'topo')), n1 = noise(r), n2 = noise(r), fade = o.fade || 0;
    var ink = mix(o.ink, o.bg, fade), bold = mix(o.bold || o.ink, o.bg, fade), acc = mix(o.accent || o.ink, o.bg, fade);
    ctx.fillStyle = o.bg; ctx.fillRect(0, 0, W, H);
    var C = Math.max(3, Math.round(S / 420)), gw = Math.ceil(W / C) + 2, gh = Math.ceil(H / C) + 2;
    var f = new Float32Array(gw * gh), ox = r() * 50, oy = r() * 50, sc = (o.scale || 1) * S / 5;
    for (var j = 0; j < gh; j++) for (var i = 0; i < gw; i++) {
      var x0 = i * C, y0 = j * C, wa = (o.warp == null ? .12 : o.warp) * S;
      var x = x0 + (n2(x0 / sc * 1.7 + 11, y0 / sc * 1.7 + 5) - .5) * wa * 2, y = y0 + (n2(x0 / sc * 1.7 + 31, y0 / sc * 1.7 + 17) - .5) * wa * 2;
      // landform mask: 0 in the empty areas, rising to 1 on the landform
      var m = 0;
      (o.land || []).forEach(function (L) {
        var d, k;
        if (L.type === 'ridge') { d = 1e9; for (var q = 0; q < L.pts.length - 1; q++) d = Math.min(d, segDist(x / W, y / H, L.pts[q][0], L.pts[q][1], L.pts[q + 1][0], L.pts[q + 1][1])); k = Math.max(0, 1 - d / L.w); }
        else { var dx = (x / W - L.x) * W / S, dy = (y / H - L.y) * H / S; d = Math.sqrt(dx * dx + dy * dy); k = Math.max(0, 1 - d / L.r); }
        k = k * k * (3 - 2 * k) * (L.h || 1); if (k > m) m = Math.max(m, k);
      });
      // warp the mask edge with noise so the landform outline is organic
      var warp = .55 * n2(x0 / sc * 1.3 + 7, y0 / sc * 1.3 + 3) + .45 * n2(x0 / sc * 3.1, y0 / sc * 3.1);
      var e = .6 * n1(x0 / sc + ox, y0 / sc + oy) + .28 * n1(x0 / sc * 2.3 + 9, y0 / sc * 2.3 + 1) + .12 * n1(x0 / sc * 5.1, y0 / sc * 5.1 + 4);
      f[j * gw + i] = m * (.55 + .9 * e) + (warp - .5) * .35 * m;
    }
    function iso(level) {
      ctx.beginPath();
      for (var j = 0; j < gh - 1; j++) for (var i = 0; i < gw - 1; i++) {
        var a = f[j * gw + i], b = f[j * gw + i + 1], c = f[(j + 1) * gw + i + 1], d = f[(j + 1) * gw + i];
        var idx = (a > level ? 8 : 0) | (b > level ? 4 : 0) | (c > level ? 2 : 0) | (d > level ? 1 : 0);
        if (idx === 0 || idx === 15) continue;
        var x = i * C, y = j * C;
        var T = [x + C * (level - a) / (b - a), y], R = [x + C, y + C * (level - b) / (c - b)], B = [x + C * (level - d) / (c - d), y + C], L = [x, y + C * (level - a) / (d - a)], s;
        switch (idx) { case 1: case 14: s = [L, B]; break; case 2: case 13: s = [B, R]; break; case 3: case 12: s = [L, R]; break;
          case 4: case 11: s = [T, R]; break; case 6: case 9: s = [T, B]; break; case 7: case 8: s = [L, T]; break; case 5: s = [L, T, B, R]; break; case 10: s = [L, B, T, R]; break; }
        for (var k = 0; k < s.length; k += 2) { ctx.moveTo(s[k][0], s[k][1]); ctx.lineTo(s[k + 1][0], s[k + 1][1]); }
      }
      ctx.stroke();
    }
    var lw = S / 1400, levels = o.lines || 22, lo = o.lo || .12, hi = o.hi || 1.25;
    ctx.lineCap = 'round'; ctx.lineJoin = 'round';
    for (var l = 0; l < levels; l++) {
      var lev = lo + (hi - lo) * l / levels, major = l % 5 === 4;
      ctx.strokeStyle = major ? bold : ink; ctx.lineWidth = (major ? 2.1 : 1) * lw * (o.weight || 1); iso(lev);
    }
    // dashed trails through the open space
    (o.trails || []).forEach(function (t) {
      ctx.beginPath();
      for (var k = 0; k <= 80; k++) { var u = k / 80, p = bez(t, u), wob = (n2(p[0] * 9, p[1] * 9) - .5) * .02; var X = (p[0] + wob) * W, Y = (p[1] + wob) * H; if (k) ctx.lineTo(X, Y); else ctx.moveTo(X, Y); }
      ctx.setLineDash([lw * 5, lw * 4]); ctx.strokeStyle = acc; ctx.lineWidth = lw * 1.6 * (o.weight || 1); ctx.stroke(); ctx.setLineDash([]);
    });
    if (o.markers !== false) {
      ctx.fillStyle = ink; ctx.strokeStyle = ink; ctx.lineWidth = lw * 1.2;
      var nM = o.crosses || 4;
      for (var q = 0; q < nM; q++) { var cx = (.06 + r() * .88) * W, cy = (.06 + r() * .88) * H, z = S * .008; ctx.beginPath(); ctx.moveTo(cx - z, cy); ctx.lineTo(cx + z, cy); ctx.moveTo(cx, cy - z); ctx.lineTo(cx, cy + z); ctx.stroke(); }
      (o.trails || []).forEach(function (t) { // little "building" squares along trails
        for (var g = 0; g < 2; g++) { var p = bez(t, .2 + r() * .6); for (var b = 0; b < 3; b++) { var z2 = S * (.0035 + r() * .003); ctx.fillStyle = acc; ctx.fillRect(p[0] * W + (r() - .5) * S * .03, p[1] * H + (r() - .5) * S * .03, z2, z2); } }
      });
    }
  }
  function bez(t, u) { var a = t[0], b = t[1], c = t[2], d = t[3], m = 1 - u;
    return [m * m * m * a[0] + 3 * m * m * u * b[0] + 3 * m * u * u * c[0] + u * u * u * d[0], m * m * m * a[1] + 3 * m * m * u * b[1] + 3 * m * u * u * c[1] + u * u * u * d[1]]; }
  if (window.Topo2) return;
  window.Topo2 = { draw: draw };
  document.dispatchEvent(new Event('topo2:ready'));
})();
